import { useQuery } from "react-query";
import { AxiosError } from "axios";
import { BaseResponse } from "../_types";
import { axiosInstance } from "../../config/axios";
import { QueryKeys } from "../queryKeys";
import { useMutation } from "react-query";

export interface IListMerchantGroupedTransactionsRequest {
  startDate: string,
  endDate: string,
  filters: any
}

export interface IListMerchantGroupedTransactionsResponse {
  merchantId: number;
    companyTitle: string;
    city: string;
    district: string;
    dateOfContract: string;
    tlTransactionsCount: number;
    tlTransactionsTotalAmount: number;
    usdTransactionsCount: number;
    usdTransactionsTotalAmount: number;
    eurTransactionsCount: number;
    eurTransactionsTotalAmount: number;
    totalTransactionsCount: number;
    firstTransactionDate: string;
    vPosTransactionsCount: number;
    benimFaturamTransactionsCount: number;
    cepPosTransactionsCount: number;
    sanalPosAPITransactionsCount: number;
}

async function listMerchantGroupedTransactions(data: IListMerchantGroupedTransactionsRequest): Promise<BaseResponse<IListMerchantGroupedTransactionsResponse>> {
  try {
    const response = await axiosInstance.post("/Merchant/MerchantGroupedTransaction", data);
    return response.data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useListMerchantGroupedTransactions() {
  return useMutation<any, Error, IListMerchantGroupedTransactionsRequest>(
    (variables) => listMerchantGroupedTransactions(variables)
  );
}
